export enum StartFeedCardTypeEnum {
  Link = 'StartFeedLinkCard',
  TemplateCategory = 'StartFeedTemplateCategoryCard',
}
